var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStromlieferung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00488E",
    className: "cls-1",
    d: "M100,35.15c-34.39,0-57.5,23.11-57.5,57.5,0,17.55,6.2,32.76,17.5,43.13v.29l1.97,1.5c5.18,3.93,8.03,10.36,8.03,18.08v4.5c0,16.25,5.38,22.46,6.46,23.54l1.46,1.46h44.14l1.46-1.46c1.08-1.08,6.46-7.29,6.46-23.54v-4.5c0-7.73,2.85-14.15,8.03-18.08l1.97-1.58v-.21c11.3-10.36,17.5-25.58,17.5-43.13,0-34.39-23.11-57.5-57.5-57.5Zm17.3,140h-34.6c-1.08-2.19-2.7-6.84-2.7-15h40c0,8.16-1.62,12.81-2.7,15Zm14.5-45.48l-1.19,1.04c-.14,.12-.28,.24-.42,.37l-.19,.17h0c-5.24,4.77-8.56,11.3-9.62,18.91h-40.75c-1.07-7.6-4.38-14.13-9.62-18.9v-.08l-1.8-1.5c-10.12-8.43-15.7-21.58-15.7-37.02,0-28.86,18.64-47.5,47.5-47.5s47.5,18.64,47.5,47.5c0,15.44-5.58,28.58-15.7,37.02Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 121,
    y: 16.15,
    width: 20,
    height: 10,
    transform: "translate(61.33 134.09) rotate(-67.5)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 64,
    y: 11.15,
    width: 10,
    height: 20,
    transform: "translate(-2.84 28.02) rotate(-22.5)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 21,
    y: 54.15,
    width: 10,
    height: 20,
    transform: "translate(-43.22 63.62) rotate(-67.5)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 164,
    y: 59.15,
    width: 20,
    height: 10,
    transform: "translate(-11.31 71.46) rotate(-22.5)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 16,
    y: 121.15,
    width: 20,
    height: 10,
    transform: "translate(-46.29 19.55) rotate(-22.5)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 169,
    y: 116.15,
    width: 10,
    height: 20,
    transform: "translate(-9.14 238.63) rotate(-67.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStromlieferung);
export default __webpack_public_path__ + "static/media/stromlieferung.b7eb85ffafa55b8bdd6de37f5d7eac94.svg";
export { ForwardRef as ReactComponent };